<template>
	<div>
		<HeadIndex></HeadIndex>
		<div ref="height_top">
			<el-row>
				<el-col :span="12" :offset="6">
					<div class="agreement-container">
						<!-- 协议标题 -->
						<h2>脱手网用户服务协议</h2>
						<!-- 重要提示 -->
						<div class="important-tip">
							<p><strong>重要提示：</strong><span class="bold-text">欢迎您使用脱手网服务平台！请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体标识，您应重点阅读。如您未满18周岁，请在法定监护人陪同下阅读本协议。</span></p>
							<p class="bold-text">除非您已阅读并接受本协议所有条款，否则您无权使用脱手网的服务。您的任何使用、登录、发布信息等行为即视为您已阅读并同意本协议的约束，本协议即在您与脱手网之间产生法律效力。</p>
						</div>
						<!-- 第1条 协议签署与修订 -->
						<h2>第1条 协议签署与修订</h2>
						<p>1.1 本协议由您（以下简称“用户”或“您”）与脱手网平台（以下简称“平台”或“我们”）共同签署。</p>
						<p>1.2 平台有权在必要时修改本协议条款，并通过网站公告、站内信、APP推送等方式予以公布。修改后的协议一经公布即生效。若您不同意修改内容，有权立即停止使用平台服务；若您继续使用，则视为接受修改后的协议。</p>
						<!-- 第2条 平台服务性质 -->
						<h2>第2条 平台服务性质</h2>
						<p>2.1 脱手网是一个专为电气元器件行业提供的<span class="bold-text">互联网信息技术服务平台</span>。我们通过PC端、APP端等产品，为用户提供<span class="bold-text">滞纳库存、二手库存信息的发布、浏览、搜索、筛选、询盘、联系等撮合与信息服务。</span></p>
						<p><span class="bold-text">2.2 平台明确声明：我们并非商户、代理商、经销商、交易一方当事人或交易参与方。我们不参与用户间的任何交易行为，包括但不限于议价、支付、交付、开具发票、质检、售后等环节。</span></p>
						<!-- 第3条 用户账号与安全 -->
						<h2>第3条 用户账号与安全</h2>
						<p>3.1 您需要注册账号并使用平台提供的服务。您承诺提供的注册信息真实、准确、完整。</p>
						<p>3.2 您的账号和密码由您自行保管，您应对您账号项下的一切活动承担全部法律责任。</p>
						<!-- 第4条 用户权利与义务 -->
						<h2>第4条 用户权利与义务</h2>
						<p>4.1 您有权在遵守本协议及相关法律法规的前提下，使用平台发布库存信息、浏览信息、与其他用户沟通。</p>
						<p>4.2 您保证，您在本平台发布的所有信息（包括但不限于文字、图片、型号、规格、数量、描述等）均<span class="bold-text">真实、准确、合法，</span>且不侵犯任何第三方的合法权益（包括但不限于知识产权、商业秘密等）。</p>
						<p>4.3 您应自行负责对交易对方的身份、信誉、履约能力及产品情况进行<span class="bold-text">独立的尽职调查与判断。</span>平台不对您的调查结果提供任何担保。</p>
						<!-- 第5条 免责声明 -->
						<h2>第5条 免责声明</h2>
						<p  class="bold-text">5.1 产品信息与质量免责：您完全理解并同意，平台仅提供信息展示服务。平台无法且不会对用户发布信息的真实性、准确性，以及所涉及产品的来源、真伪、质量、性能、安全、权利瑕疵、是否滞纳或二手等情况进行任何形式的审查、保证或担保。所有信息均由发布者自行提供并承担责任。</p>
						<p  class="bold-text">5.2 交易风险免责：因使用本平台服务所产生的任何交易风险、纠纷、损失（包括但不限于经济损失、商誉损失），均由交易双方自行协商解决并承担全部责任。平台无需向用户承担任何形式的责任，除非该损失是由于平台的故意或重大过失直接导致。</p>
						<p  class="bold-text">5.3 平台状态免责：鉴于互联网服务的特殊性，平台不保证服务不会中断，也不保证服务的及时性、安全性、准确性，但将尽力维护服务的稳定运行。</p>
						<!-- 第6条 知识产权 -->
						<h2>第6条 知识产权</h2>
						<p>6.1 平台所有的知识产权归平台所有。</p>
						<p>6.2 您通过本平台发布的信息，您授予平台一项全球性的、免费的、非独占的许可以使用权。</p>
						<!-- 第7条 隐私政策 -->
						<h2>第7条 隐私政策</h2>
						<p>平台对您的个人信息将按照公布的《隐私政策》进行保护与使用。《隐私政策》构成本协议不可分割的一部分。</p>
						<!-- 第8条 违约与处理 -->
						<h2>第8条 违约与处理</h2>
						<p>8.1 如您违反本协议或相关法规，平台有权采取包括但不限于警告、限制发布、删除信息、暂停服务、终止合作等处理措施。</p>
						<p>8.2 如果您的行为使平台遭受损失，平台有权向您追偿。</p>
						<!-- 第9条 责任限制 -->
						<h2>第9条 责任限制</h2>
						<p  class="bold-text">在法律允许的最大范围内，脱手网及其关联方对因使用本服务而导致的任何间接、偶然、特殊、后果性的损失或损害（包括但不限于利润损失、商誉损失、数据丢失、业务中断等）不承担任何责任，无论其原因为何，也无论是否已被告知此种损害的可能性。</p>
						<!-- 第10条 法律适用与争议解决 -->
						<h2>第10条 法律适用与争议解决</h2>
						<p>10.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
						<p>10.2 <span >因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权将争议提交至<span class="bold-text">平台运营主体所在地有管辖权的人民法院</span>提起诉讼。</span></p>
						<!-- 第11条 其他 -->
						<h2>第11条 其他</h2>
						<p>11.1 本协议任何条款被认定为无效或不执行，不影响其他条款的效力。</p>
						<p>11.2 本协议最终解释权归脱手网所有。</p>
						<!-- 确认同意区域 -->
						<div class="agree-section"><span class="bold-text">
							请您再次确认：您已充分阅读、理解并接受以上《用户服务协议》的全部内容，特别是加粗部分的免责条款。如果您点击“同意”或类似选项，或继续使用脱手网的服务，即表示您接受本协议的约束。</span>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-row class="logo_m">
			<el-col :span="24">
				<div>
					CopyRight © 脱手网 2018 苏ICP备18008659号
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import HeadIndex from '../public/HeadIndex';
export default {
	name: 'product',
	components: {
		HeadIndex
	},
	data() {

		return {

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {

		this.tableHeight_fun();
	},
	watch: {

	},
	methods: {
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
			})
		},
	}
}
</script>
<style lang="less" scoped>
body {
	font-family: "Microsoft YaHei", Arial, sans-serif;
	line-height: 1.8;
	color: #333;
	padding: 20px;
	max-width: 1000px;
	margin: 0 auto;
	background-color: #f9f9f9;
}

.agreement-container {
	background-color: #fff;
	padding: 30px;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.important-tip {
	background-color: #fff8e6;
	border-left: 4px solid #ff9f43;
	padding: 15px 20px;
	margin-bottom: 30px;
	border-radius: 4px;
}

.important-tip strong {
	color: #e64a19;
}

h2 {
	font-size: 22px;
	color: #222;
	margin: 35px 0 15px;
	padding-bottom: 8px;
	border-bottom: 1px solid #eee;
}

h2:first-child {
	margin-top: 0;
	font-size: 24px;
	text-align: center;
	border-bottom: none;
}

p {
	margin: 12px 0;
	text-align: justify;
}

.bold-text {
	font-weight: bold;
	//color: #d32f2f;
	/* 重点条款标红加粗 */
}

.agree-section {
	margin-top: 40px;
	padding-top: 20px;
	border-top: 1px solid #eee;
	display: flex;
	align-items: center;
	gap: 12px;
}

.agree-checkbox {
	width: 18px;
	height: 18px;
	cursor: pointer;
}

.agree-text {
	font-size: 15px;
	color: #444;
}

.agree-btn {
	padding: 10px 24px;
	background-color: #2196f3;
	color: #fff;
	border: none;
	border-radius: 4px;
	font-size: 15px;
	cursor: pointer;
	margin-left: 20px;
	transition: background-color 0.3s;
}

.agree-btn:hover {
	background-color: #1976d2;
}

/* 响应式适配 */
@media (max-width: 768px) {
	.agreement-container {
		padding: 20px 15px;
	}

	h2 {
		font-size: 20px;
	}

	.agree-section {
		flex-direction: column;
		align-items: flex-start;
	}

	.agree-btn {
		margin-left: 0;
		margin-top: 15px;
		width: 100%;
		padding: 12px 0;
	}
}
:deep(.el-input-group__append) {
	background: #ff8a5c;
}
</style>